import { Injectable, Optional, SkipSelf } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateService {
	constructor(
		@Optional() @SkipSelf() previousInstance?: DateService //
	) {
		if (previousInstance) {
			throw new Error(
				'DateService is already loaded. Import it in the AppModule only');
		}
	}

	public getWeekNumber(date: Date): number {
		let tmp = new Date(date.getTime());
		tmp.setHours(0, 0, 0, 0);
		// Thursday in current week decides the year.
		tmp.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
		// January 4 is always in week 1.
		let week1 = new Date(date.getFullYear(), 0, 4);
		// Adjust to Thursday in week 1 and count number of weeks from date to week1.
		let week = 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000
			- 3 + (week1.getDay() + 6) % 7) / 7);

		return week;
	}

	public getWeekAsString(date: Date | undefined | null): string {
		if (!date)
			return "";

		let week = this.getWeekNumber(date);
		let year = date.getFullYear();

		return "S" + week + "/" + year;
	}

	public getTodayAtMidnight(): Date {
		let today = new Date();
		today.setHours(0, 0, 0, 0);
		return today;
	}

	public minusDays(date: Date, days: number): Date {
		let newDate = new Date(date);
		newDate.setDate(newDate.getDate() - days);
		return newDate;
	}

	public minusMonths(date: Date, months: number): Date {
		let newDate = new Date(date);
		newDate.setMonth(date.getMonth() - months);
		return newDate;
	}
	
	public firstDayOfSameWeek(date: Date): Date {
		let tmp = new Date(date);
		tmp.setDate(date.getDate() - (date.getDay() + 6) % 7);
		tmp.setHours(0, 0, 0, 0);
		return tmp;
	}

	public getRoundedDateAndTime(dt: Date): Date {
		let result = new Date(dt.getTime());
		let minutes = result.getMinutes();
		let minutesMod5 = minutes % 5;
		if (minutesMod5 > 0) {
			var minutesDessusDessous = (minutesMod5 >= 3) ? 5 : 0;
			minutes += (minutesDessusDessous - minutesMod5);
		}
		result.setMinutes(minutes);
		result.setSeconds(0);
		result.setMilliseconds(0);
		return result;
	}

	public getCurrentRoundedDateAndTime(): Date {
		let now = new Date();
		return this.getRoundedDateAndTime(now);
	}
	
	public addMinutesToDate(dt: Date, numberOfMinutesToAdd: number): Date | null {
		if (dt) {
			let result = new Date(dt.getTime());
			let minutes = result.getMinutes() + numberOfMinutesToAdd;
			result.setMinutes(minutes);
			result.setSeconds(0);
			result.setMilliseconds(0);
			return result;
		}
		return null;
	}
}